"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ledger = void 0;
var react_1 = __importStar(require("react"));
var react_loader_spinner_1 = require("react-loader-spinner");
var connectors_1 = require("../connectors");
var use_contractkit_1 = require("../use-contractkit");
var useIsMounted_1 = require("../utils/useIsMounted");
var Ledger = function (_a) {
    var onSubmit = _a.onSubmit;
    var _b = (0, use_contractkit_1.useContractKitInternal)(), network = _b.network, initConnector = _b.initConnector, error = _b.initError, feeCurrency = _b.feeCurrency;
    var _c = __read((0, react_1.useState)(false), 2), submitting = _c[0], setSubmitting = _c[1];
    var _d = __read((0, react_1.useState)('0'), 2), index = _d[0], setIndex = _d[1];
    var isMountedRef = (0, useIsMounted_1.useIsMounted)();
    var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var connector, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSubmitting(true);
                    connector = new connectors_1.LedgerConnector(network, parseInt(index, 10), feeCurrency);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, initConnector(connector)];
                case 2:
                    _a.sent();
                    onSubmit(connector);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    if (isMountedRef.current) {
                        setSubmitting(false);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "tw-p-2" },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "tw-flex" },
                react_1.default.createElement("div", { className: "tw-flex tw-flex-col" },
                    react_1.default.createElement("div", { className: "tw-text-lg tw-mb-1 tw-font-medium dark:tw-text-gray-200 tw-text-center" }, "Ledger Connect"),
                    react_1.default.createElement("p", { className: "tw-mt-3 tw-text-sm tw-text-gray-600 dark:tw-text-gray-400" }, "Securely connect to your ledger device. Before proceeding, please ensure you have:"),
                    react_1.default.createElement("ul", { className: "tw-list-disc tw-text-sm tw-text-gray-600 tw-list-inside tw-mt-4" },
                        react_1.default.createElement("li", null, "Connected your Ledger (via USB)"),
                        react_1.default.createElement("li", null, "Unlocked your Ledger"),
                        react_1.default.createElement("li", null,
                            "Opened the",
                            ' ',
                            react_1.default.createElement("a", { href: "https://docs.celo.org/celo-owner-guide/ledger", target: "_blank", rel: "noopener noreferrer" }, "Celo application"),
                            ' ')),
                    react_1.default.createElement("p", { className: "tw-text-sm tw-text-gray-600 dark:tw-text-gray-400 tw-mt-4" },
                        "Connect to account at index",
                        ' ',
                        react_1.default.createElement("input", { type: "number", className: "tw-ml-1 tw-text-center tw-text-gray-700 dark:tw-text-gray-300 tw-border border-light-gray-700 dark:border-light-gray-300 tw-rounded tw-outline-none focus:tw-outline-none", style: { width: '40px', background: 'unset' }, value: index, onChange: function (e) { return setIndex(e.target.value); }, disabled: submitting })),
                    error && (react_1.default.createElement("p", { className: "tw-mt-4 tw-text-xs tw-text-red-600" }, error.message)),
                    react_1.default.createElement("button", { className: "tw-mt-6 tw-px-4 tw-py-2 tw-border tw-border-transparent tw-rounded-md tw-shadow-sm tw-text-base tw-font-medium tw-text-white tw-bg-gradient-to-r tw-from-purple-600 tw-to-indigo-600 hover:tw-from-purple-700 hover:tw-to-indigo-700", onClick: submit, disabled: submitting }, submitting ? (react_1.default.createElement("div", { className: "tw-flex tw-items-center tw-justify-center" },
                        react_1.default.createElement(react_loader_spinner_1.TailSpin, { color: "white", height: 24, width: 24 }))) : ('Connect')))))));
};
exports.Ledger = Ledger;
//# sourceMappingURL=ledger.js.map